import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';

const StandardCell = ({ row, field }) => {
  function renderCell() {
    switch (field) {
      case 'is_canonical':
        return (
          <Icon
            icon={faCheckCircle}
            className={row.is_canonical ? 'block text-green-900' : 'hidden'}
          />
        );
      case 'owner':
        return <span>{`${row[field].first_name} ${row[field].last_name}`}</span>;
      default:
        return <span>{row[field]}</span>;
    }
  }

  return renderCell();
};

export default StandardCell;
